import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Bell } from "lucide-react";
import { myNotifications, readAllNotifications, readNotification } from "../../api/payroll";
import { usePoll } from "../../hooks/usePoll";
import { mirrorToSystem } from "../../lib/notifyMirror";
import { NotificationSheet } from "./NotificationSheet";

export const NotificationBell = () => {
  const { t } = useTranslation();
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const seen = useRef(null); // أول تحميل: نسجّل الموجود دون عرضه؛ لاحقاً نعكس الجديد فقط.

  const load = async () => {
    try {
      const fresh = await myNotifications();
      const items = fresh.items || [];
      if (items.some((n) => n.kind === "feature_enabled" || n.kind === "feature_disabled")) {
        window.dispatchEvent(new CustomEvent("features:refresh"));
      }
      if (seen.current === null) seen.current = new Set(items.map((i) => i.id));
      else mirrorToSystem(items, seen.current);
      setData(fresh);
    } catch {
      /* silent */
    }
  };

  useEffect(() => {
    load();
  }, [open]);

  usePoll(() => {
    if (!open) load();
  }, 30000, [open]);

  const markOne = async (id) => {
    await readNotification(id);
    load();
  };
  const markAll = async () => {
    await readAllNotifications();
    load();
  };

  return (
    <div className="relative">
      <button
        type="button"
        data-testid="notification-bell"
        onClick={() => setOpen((prev) => !prev)}
        className="relative rounded-2xl p-2.5 shadow-neu-sm transition-[box-shadow] duration-300 hover:shadow-neu-in"
        aria-label={t("notifications.title")}
      >
        <Bell className="h-[1.55rem] w-[1.55rem]" strokeWidth={2.3} />
        {data.unread ? (
          <span
            data-testid="notification-badge"
            className="absolute -end-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1 font-mono text-[10px] font-black text-white"
          >
            {data.unread}
          </span>
        ) : null}
      </button>

      {open ? (
        <NotificationSheet
          items={data.items}
          unread={data.unread}
          onRead={markOne}
          onReadAll={markAll}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </div>
  );
};
